import { render, staticRenderFns } from "./TableRoute.vue?vue&type=template&id=58ace4b2&scoped=true&"
import script from "./TableRoute.vue?vue&type=script&lang=ts&"
export * from "./TableRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ace4b2",
  null
  
)

export default component.exports